import React from 'react';
import { Typography } from '@mui/material';
import PolicyHeader from './PolicyHeader';
import Policy from './Policy';
import { aboutFaqData } from './AboutUsData';

function Faq() {
  const searchParams = new URLSearchParams(window.location.search);
  const isMobileParams = searchParams.get('isMobile') === 'true';
  return (
    <div>
      {!isMobileParams && <PolicyHeader/>}
      <div className="aboutBackground">
      { !isMobileParams &&<Typography className="headerText justifyCenter fw500 pt20 pb30">
          FAQ
        </Typography>}
        <Policy policyData={aboutFaqData} />
      </div>
    </div>
  );
}

export default Faq;
